import { Avatar, Box, Typography } from "@mui/material";

export function AccountManagerAvatar(props: { value?: { readonly id: string; readonly name: string } }) {
  const accountManager = props.value;
  if (!accountManager) {
    return <></>;
  }
  return (
    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
      <Avatar sx={{ width: 40, height: 40 }}>{accountManager.name.substring(0, 2)}</Avatar>
      <Box sx={{ ml: 1, display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            lineHeight: 1,
          }}
        >
          Twój doradca klienta
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "600",
          }}
        >
          {accountManager.name}
        </Typography>
      </Box>
    </Box>
  );
}
